import type { GetServerSidePropsContext } from "next";

import { getCookieValue } from "../get-cookie-value";

const COOKIE_NAME_SPLIT_E2E_FEATURE_FLAG_OVERRIDES =
  "flare-e2e-split-feature-flag-overrides";

interface Override {
  featureFlagName: string;
  value: {
    config: Record<string, unknown>;
    isOn: boolean;
    isReady: boolean;
  };
}

type CookieValue = Record<string, Override>;

export function getE2ESplitFeatureFlagOverrides(
  req?: GetServerSidePropsContext["req"],
): CookieValue | null {
  return getCookieValue(COOKIE_NAME_SPLIT_E2E_FEATURE_FLAG_OVERRIDES, req);
}

export function getE2eSplitFeatureFlagOverride(
  featureFlagName: string,
  req?: GetServerSidePropsContext["req"],
): Override["value"] | null {
  const featureFlagOverrides = getE2ESplitFeatureFlagOverrides(req);

  const featureFlagOverride = featureFlagOverrides?.[featureFlagName];

  if (!featureFlagOverride) {
    return null;
  }

  const override = featureFlagOverride?.value;

  if (!override) {
    return null;
  }

  return override;
}
